import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, withStyles } from '@material-ui/core';
import { Loader, colors, Typography } from 'kangarootime-ui';
import './ChildTable.css';
import Row from './Row';
import RaisedContainer from '../../../components/RaisedContainer';

const CustomTableSortLabel = withStyles(theme => ({
  icon: {
    fill: colors.brand_4
  }
}))(TableSortLabel);

const ChildTable = ({ rows, selectRow, loading, orderBy, order, onRequestSort, selectPhotoTakenToday }) => {
  // bubble sort selection up to parent
  const createSortHandler = property => event => onRequestSort(event, property);

  const getSorting = (order, orderBy) => {
    const sortingNumbers = orderBy !== 'last_name';

    return order === 'desc' ? (a, b) => orderDesc(a, b, orderBy, sortingNumbers) : (a, b) => -orderDesc(a, b, orderBy, sortingNumbers);
  };

  /**
   * Sorting function
   * @param {Object} a - first object
   * @param {Object} b - second object
   * @param {orderBy} String - property to use for sorting
   * @param {Boolean} sortingNumbers - property to sort by are numbers. Default value is `false`
   */
  const orderDesc = (a, b, orderBy, sortingNumbers = false) => {
    let _a = a[orderBy];
    let _b = b[orderBy];

    if (sortingNumbers) {
      _a = parseInt(_a, 10);
      _b = parseInt(_b, 10);
    }

    if (_b < _a) {
      return -1;
    }

    if (_b > _a) {
      return 1;
    }

    return 0;
  };

  // source from material-ui's table documentation
  const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);

    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });

    return stabilizedThis.map(el => el[0]);
  };

  return (
    <RaisedContainer>
      <Table>
        <TableHead style={{ backgroundColor: '#F1F1F3' }}>
          <TableRow>
            <TableCell>
              <CustomTableSortLabel
                active={orderBy === 'last_name'}
                direction={order}
                onClick={createSortHandler('last_name')}
              >
                <Typography>Child</Typography>
              </CustomTableSortLabel>
            </TableCell>
            <TableCell>
              <Typography>Photos Taken Today</Typography>
            </TableCell>
            <TableCell>
              <CustomTableSortLabel
                active={orderBy === 'numberOfPhotosTakenToday'}
                direction={order}
                onClick={createSortHandler('numberOfPhotosTakenToday')}
              >
                <Typography>Daily Total</Typography>
              </CustomTableSortLabel>
            </TableCell>
            <TableCell>
              <CustomTableSortLabel
                active={orderBy === 'child_photo_count'}
                direction={order}
                onClick={createSortHandler('child_photo_count')}
              >
                <Typography>Gallery Total</Typography>
              </CustomTableSortLabel>
            </TableCell>
          </TableRow>
        </TableHead>
        <Loader loading={loading}>
          <TableBody>
            { stableSort(rows, getSorting(order, orderBy)).map(child => (
              <Row
                key={child.child_id}
                child={child}
                onRowSelect={selectRow}
                selectPhoto={selectPhotoTakenToday}
              />
            ))}
          </TableBody>
        </Loader>
      </Table>
    </RaisedContainer>
  );
};

export default ChildTable;
